import { useMutation } from 'query';
import { useUpdatePollVote } from '../../hooks';
import { addVote } from '../../services';

type AddVote = { choice: string; pollId?: string };

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const useAddVoteMutation = () => {
  const updateCache = useUpdatePollVote({ action: 'vote' });

  return useMutation<unknown, AddVote>({
    mutationFn: async ({ choice }) => addVote(choice),
    onSuccess(_data, params) {
      updateCache(params);
    },
  });
};
